import React, { Component } from 'react';
import { Field, FieldArray, reset } from 'redux-form'
import ReactDataGrid from 'react-data-grid';
import { Data, CheckboxEditor } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button} from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';

class RowRenderer extends Component {

    PropTypes: {
      onDoubleClick: React.PropTypes.func
    };

    render() {
        return (<div onDoubleClick={ ()=>{ this.props.onDoubleClick(this.props.row, this.props.field) } } ><ReactDataGrid.Row ref="row" {...this.props} /></div>)
    }
}

export class MeasurementUnit extends Component {
  constructor() {
    super();
    this.state = {
      measurementUnit: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      }
    }
    this.addMeasurementUnit = this.addMeasurementUnit.bind(this);
    this.editMeasurementUnit = this.editMeasurementUnit.bind(this);
    this.deleteMeasurementUnit = this.deleteMeasurementUnit.bind(this);
  }

  componentWillMount() {
    this.props.fetchMeasurementUnit();
  }

  componentWillUnmount() {
    this.props.clearMeasurementUnitEdited()
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.measurementUnitFetched && nextProps.measurementUnitFetched != this.props.measurementUnitFetched) {
      let measurementUnitFetched = nextProps.measurementUnitFetched;
      let index = 0;
      measurementUnitFetched.map(mmUnit => {
        mmUnit.Idx = index++;
      })
      let measurementUnit = {...this.state.measurementUnit, rows: measurementUnitFetched}
      this.setState({measurementUnit})
    }
    if(nextProps.measurementUnitEdited && nextProps.measurementUnitEdited != this.props.measurementUnitEdited) {
      this.props.fetchMeasurementUnit();
      let measurementUnit = {...this.state.measurementUnit, selectedRows: null}
      this.setState({measurementUnit})
    }
  }

  addMeasurementUnit() {
    let rows = [...this.state.measurementUnit.rows]
    rows.push({MeasureUnit_id: 0, Name: "", Description: "", Simple: "", Idx: rows.length})
    let measurementUnit = { ...this.state.measurementUnit, rows }
    this.setState({measurementUnit})
  }

  editMeasurementUnit() {
    this.props.editMeasurementUnit(this.state.measurementUnit.rows)
  }

  deleteMeasurementUnit(event) {
    event.preventDefault();
    let measureUnit_id = this.state.measurementUnit.selectedRows[0].MeasureUnit_id;
    if(measureUnit_id != 0) {
      this.props.deleteMeasurementUnit(measureUnit_id);
      let measurementUnit = {...this.state.measurementUnit, selectedRows: []};
      this.setState({measurementUnit})
    }
    else {
      let rows = [...this.state.measurementUnit.rows];
      let index = _.findIndex(rows, {Idx: this.state.measurementUnit.selectedRows[0].Idx})
      rows.splice(index, 1);
      let measurementUnit = {...this.state.measurementUnit, rows, selectedRows: []};
      this.setState({measurementUnit})
    }
  }

  render() {
    if (this.props.fetchingMeasurementUnit && !this.props.measurementUnitFetchError) return <Spinner/>
    else if (this.props.measurementUnitFetchError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.measurementUnitFetchError)}</div></ContentWrapper>
    else {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.measurementUnit);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var measurementUnit = Object.assign({}, this.state.measurementUnit, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({measurementUnit});
        }

        const handleRowUpdated = e => {
          var rows = getRows();
          Object.assign(rows[e.rowIdx], e.updated);
          let measurementUnit = {...this.state.measurementUnit, rows}
          this.setState({measurementUnit})
          this.props.clearMeasurementUnitEdited()
        }

        const onRowsSelected = (rows) => {
             let newRows = getRows();
             newRows.map(r => {
               r.isSelected = false;
             })
             rows.map (r => {
               newRows[r.rowIdx].isSelected = true;
             });
             let measurementUnit = {...this.state.measurementUnit, rows: newRows, selectedRows: [rows[0].row]}
             this.setState({measurementUnit});
        }

         const onRowsDeselected = (rows) => {
             let newRows = getRows();
             rows.map (r => {
               newRows[r.rowIdx].isSelected = false;
             });
             let measurementUnit = {...this.state.measurementUnit, rows: newRows, selectedRows: []}
             this.setState({measurementUnit});
         }
        // Column difinition

        const columns = [
          {
              key: 'Name',
              name: <Translate value="name"/>,
              resizable: true,
              sortable: true,
              width: 100,
              editable: true,
              // filterRenderer: FilterByStart,
          },
          {
              key: 'Description',
              name: <Translate value="desc"/>,
              resizable: true,
              sortable: true,
              width: 100,
              editable: true,
              // filterRenderer: FilterByStart,
          },
          {
              key: 'Simple',
              name: <Translate value="simple"/>,
              resizable: true,
              sortable: true,
              width: 100,
              editable: true,
          },
        ]

        return (
          <div>
            <ButtonToolbar>
              <Button onClick={this.addMeasurementUnit} disabled={!checkPermission('add_product_group')}><em className="fa fa-plus"/><Translate value="create"/></Button>
              <Button
                bsStyle="success"
                onClick={this.editMeasurementUnit}
                disabled={!checkPermission('change_product_group')}
              >
                <em className="fa fa-save marginRightStyle" /><Translate value="save"/>
              </Button>
                <Button
                  bsStyle="danger"
                  className="buttonStyle"
                  onClick={(event) => { this.deleteMeasurementUnit(event)}}
                  disabled={!this.state.measurementUnit.selectedRows || this.state.measurementUnit.selectedRows.length != 1 || !checkPermission('delete_product_group')}
                  ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                </Button>
            </ButtonToolbar>
            <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="MeasurementUnit-dataGrid1">
                <ReactDataGrid
                    rowRenderer={<RowRenderer onDoubleClick={this.props.selectMeasurementUnit} field={this.props.field}/>}
                    rowKey='MeasurementUnit_id'
                    rowHeight={25}
                    minHeight={620}
                    onGridSort={handleGridSort}
                    enableRowSelect='single'
                    columns={columns}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    enableCellSelect={true}
                    onRowUpdated={handleRowUpdated}
                    rowSelection={{
                      showCheckbox: true,
                      onRowsSelected: onRowsSelected,
                      onRowsDeselected: onRowsDeselected,
                      selectBy: {
                        isSelectedKey: 'isSelected'
                      }
                    }}
                />
            </div></Col></Row>
            <br/>
            {
              this.props.editingMeasurementUnit &&
              <div className="alert alert-info measure-unit-saving-info"><span className=""><Translate value="saving"/></span></div>
            }
            {
              this.props.measurementUnitEdited &&
              <div className="alert alert-success measure-unit-saving-info">
                <span className=""><Translate value="saved" /></span>
              </div>
            }
            {
              this.props.measurementUnitEditError &&
              <div className="alert alert-danger measure-unit-saving-info">
                <span className="">{this.props.measurementUnitEditError}</span>
              </div>
            }
            {
              this.props.deletingMeasurementUnit &&
              <div className="alert alert-info measure-unit-saving-info"><span className=""><Translate value="deleting"/></span></div>
            }
            {
              this.props.deleteMeasurementUnitSuccess &&
              <div className="alert alert-success measure-unit-saving-info">
                <span className=""><Translate value="deleted"/></span>
              </div>
            }
            {
              this.props.deleteMeasurementUnitError &&
              <div className="alert alert-danger measure-unit-saving-info">
                <span className="">{this.props.deleteMeasurementUnitError}</span>
              </div>
            }
        </div>
        )
      }
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Products/measurementUnit.jsx